import apiClient from './client';

export interface AuthResponse {
  access_token: string;
}

export async function exchangeAuth0Token(auth0AccessToken: string): Promise<string> {
  const response = await apiClient.post<AuthResponse>(
    '/oms/auth/auth0',
    {},
    {
      headers: {
        Authorization: `Bearer ${auth0AccessToken}`,
      },
    },
  );
  return response.data.access_token;
}
